import React, { useEffect, useRef, Suspense } from 'react';
import { BrowserRouter, Routes, Route, Navigate, useLocation, useParams } from "react-router-dom";
//import logo from '../assets/images/logo.svg';
//import '../assets/css/App.css';
//import { UseAuth } from "../hooks/useAuth";
//import { isMobile } from 'react-device-detect';
import ReactGA from "react-ga4";

// My Components
//import Header from "./Header"
import PrivateRoute from './PrivateRoute'
//import DownloadsPage from "./DownloadsPage"
import CreatorsPage from './CreatorsPage';
//import BlogPage from './Pages/BlogPage';
//import BlogDetailPage from './Pages/BlogDetailPage';
import MetaHandler from './MetaHandler';
import GlobalMetaPixel from './GlobalMetaPixel';
import CookieConsent from './CookieConsent';

//import SignInScreen from "./SignIn"
const LoginScreen = React.lazy(() => import("./Login"));
//import NotFound from "./NotFound"
const Dashboard = React.lazy(() => import("./Admin/Dashboard"));
const DashboardUserProfile = React.lazy(() => import("./Admin/DashboardUserProfile"));
const PaymentSuccessAdmin = React.lazy(() => import("./Admin/PaymentSuccessAdmin"));
const PaymentFailureAdmin = React.lazy(() => import("./Admin/PaymentFailureAdmin"));
const NotFoundAdmin = React.lazy(() => import("./Admin/NotFoundAdmin"));
const RedeemedUserLists = React.lazy(() => import("./Admin/RedeemedUserLists"));
const MarketPlaceListsAdmin = React.lazy(() => import("./Admin/MarketPlaceListsAdmin"));
const ArchivedMarketPlaceListsAdmin = React.lazy(() => import("./Admin/ArchivedMarketPlaceListsAdmin"));
const AdminDetailPage = React.lazy(() => import("./Admin/AdminDetailPage"));
const AdminNotificationSender = React.lazy(() => import("./Admin/AdminNotificationSender"));
const AdminPromotionalNotificationSender = React.lazy(() => import("./Admin/AdminPromotionalNotificationSender"));
const ReferralPayoutUserLists = React.lazy(() => import("./Admin/ReferralPayoutUserLists"));
const AdminSubscribedUsersList = React.lazy(() => import("./Admin/AdminSubscribedUsersList"));
const AdminProfileSubscriptionsList = React.lazy(() => import("./Admin/AdminProfileSubscriptionsList"));
const ExperienceListsAdmin = React.lazy(() => import("./Admin/ExperienceListsAdmin"));
const ExperienceDraftsAdmin = React.lazy(() => import("./Admin/ExperienceDraftsAdmin"));
const ExperienceDraftDetailPage = React.lazy(() => import("./Admin/ExperienceDraftDetailPage"));
const ExperienceDetailPage = React.lazy(() => import("./Admin/ExperienceDetailPage"));
const CreatorLeadsList = React.lazy(() => import("./Admin/CreatorLeadsList"));
const CreatorLeadDetail = React.lazy(() => import("./Admin/CreatorLeadDetail"));
const CreatorStatsAdmin = React.lazy(() => import("./Admin/CreatorStatsAdmin"));
//import LandingPage from "./LandingPage"
const LandingPageNew = React.lazy(() => import('./LandingPageNew'));
const ContactUs = React.lazy(() => import("./Pages/ContactUs"));
const AboutUs = React.lazy(() => import("./Pages/AboutUs"));
const TermsUSA = React.lazy(() => import("./Pages/TermsUSA"));
const TermsIndia = React.lazy(() => import("./Pages/TermsIndia"));
const PrivacyPolicyUSA = React.lazy(() => import("./Pages/PrivacyPolicyUSA"));
const PrivacyPolicyIndia = React.lazy(() => import("./Pages/PrivacyPolicyIndia"));
const FAQPage = React.lazy(() => import("./Pages/FAQPage"));
const GuidelinesAndProcedure = React.lazy(() => import("./Pages/GuidelinesAndProcedure"));
const ReferAndEarnTOS = React.lazy(() => import("./Pages/ReferAndEarnTOS"));
const CreateShareEarn = React.lazy(() => import("./Pages/CreateShareEarn"));
const MarketplaceDrawTos = React.lazy(() => import("./Pages/MarketplaceDrawTos"));
const VaSiCreatorMonetizationGuidelines = React.lazy(() => import("./Pages/VaSiCreatorMonetizationGuidelines"));
const VaSiSubscriberGuidelines = React.lazy(() => import("./Pages/VaSiSubscriberGuidelines"));
const TasksCreatorGuide = React.lazy(() => import("./Pages/TasksCreatorGuide"));
const ExperiencesTos = React.lazy(() => import("./Pages/ExperiencesTos"));
const DetailPage = React.lazy(() => import("./DetailPage"));

const ConsumerLandingPage = React.lazy(() => import('./ConsumerLandingPage'));
const ConsumerLandingPageV2 = React.lazy(() => import('./consumer-landing-v2/ConsumerLandingPageV2'));
const AdminUserList = React.lazy(() => import('./Admin/AdminUserList'));
const DeactivateRequestsList = React.lazy(() => import('./Admin/DeactivateRequestsList'));
const VasiWelcomeMobile = React.lazy(() => import('./Pages/VasiWelcomeMobile'));
const DeepLinkHandler = React.lazy(() => import('./DeepLinkHandler'));
const DeepLinkEntryHandler = React.lazy(() => import('./DeepLinkEntryHandler'));
const ExperienceLandingPage = React.lazy(() => import('./ExperienceLandingPage'));
const ExperienceLandingPageV2 = React.lazy(() => import('./ExperienceLandingPageV2'));
const RegisteredSuccess = React.lazy(() => import('./Pages/RegisteredSuccess'));
const RegisteredCancel = React.lazy(() => import('./Pages/RegisteredCancel'));
const ConfirmingScreen = React.lazy(() => import('./Pages/ConfirmingScreen'));
const SuccessScreen = React.lazy(() => import('./Pages/SuccessScreen'));
const SuccessScreenPreview = React.lazy(() => import('./Pages/SuccessScreenPreview')); // TEMP DEBUG — remove before commit
const SeatsFullScreen = React.lazy(() => import('./Pages/SeatsFullScreen'));
const PaymentFailedScreen = React.lazy(() => import('./Pages/PaymentFailedScreen'));
const AboutUsV2 = React.lazy(() => import('./PagesV2/AboutUsV2'));
const FAQPageV2 = React.lazy(() => import('./PagesV2/FAQPageV2'));
const ContactUsV2 = React.lazy(() => import('./PagesV2/ContactUsV2'));
const BecomeAHost = React.lazy(() => import('./PagesV2/BecomeAHost'));
const CreatorLandingPage = React.lazy(() => import('./PagesV2/CreatorLandingPage'));
const LiveSessionPage = React.lazy(() => import('./LiveSessionPage'));
const ExperienceRecordingsPage = React.lazy(() => import('./ExperienceRecordingsPage'));

// /live/:experienceId carries the one-time join code as ?c=. LiveSessionPage strips it
// from the address bar, but this component's pageview fires first -- it is mounted
// eagerly, above the lazily loaded route -- so without this the code would be logged to
// GA in full before the route ever renders. Nothing else reads `c`.
function scrubTrackedSearch(search) {
  if (!search) return search;
  try {
    const params = new URLSearchParams(search);
    if (!params.has('c')) return search;
    params.delete('c');
    const rest = params.toString();
    return rest ? `?${rest}` : '';
  } catch (e) {
    return '';
  }
}

function AnalyticsTracker() {
  const location = useLocation();
  const isInitialized = useRef(false);
  const trackingId = process.env.REACT_APP_TRACKING_ID;

  useEffect(() => {
    if (!trackingId || isInitialized.current) return;
    ReactGA.initialize(trackingId);
    isInitialized.current = true;
  }, [trackingId]);

  useEffect(() => {
    if (!trackingId) return;
    ReactGA.send({
      hitType: "pageview",
      page: `${location.pathname}${scrubTrackedSearch(location.search)}`
    });
  }, [location.pathname, location.search, trackingId]);

  return null;
}

function ShareRouteFallback() {
  const { hostname, experienceId } = useParams();
  const location = useLocation();
  if (!hostname || !experienceId) return <Navigate to="/" replace />;

  const destination = `/${encodeURIComponent(hostname)}/${encodeURIComponent(experienceId)}${location.search || ""}${location.hash || ""}`;
  return <Navigate to={destination} replace />;
}

function RouteLoadingFallback() {
  // Temporarily disabled (logo treatment didn't look good) — rendering null here
  // means #root stays childless during this Suspense state, so the #root:empty
  // background/logo placeholder in public/index.html shows through instead.
  return null;
}

function App() {
  const useV2InfoPages = process.env.REACT_APP_V2_INFO_PAGES === 'true';


  return (
    <BrowserRouter>
      <AnalyticsTracker />
      <MetaHandler />
      <GlobalMetaPixel />
      {/* <CookieConsent /> */}
      <div>
        <Suspense fallback={<RouteLoadingFallback />}>
        <Routes>

          <Route path="*" element={<NotFoundAdmin />} />

          <Route path='/details'>
            <Route path='/details' element={<DetailPage />} />
          </Route>

          <Route path='/dots'>
            <Route path='/dots' element={<DetailPage />} />
          </Route>


          <Route path='/dashboard' element={<PrivateRoute />}>
            <Route path='/dashboard' element={<Dashboard />} />
          </Route>

          <Route path='/dots-details/:id' element={<PrivateRoute />}>
            <Route path='/dots-details/:id' element={<AdminDetailPage />} />
          </Route>

          <Route path='/dashboard/profile/:userId' element={<PrivateRoute />}>
            <Route path='/dashboard/profile/:userId' element={<DashboardUserProfile />} />
          </Route>

          <Route path='/dashboard/success/' element={<PrivateRoute />}>
            <Route path='/dashboard/success/' element={<PaymentSuccessAdmin />} />
          </Route>

          <Route path='/dashboard/canceled/' element={<PrivateRoute />}>
            <Route path='/dashboard/canceled/' element={<PaymentFailureAdmin />} />
          </Route>

          <Route path='/dashboard/payouts' element={<PrivateRoute />}>
            <Route path='/dashboard/payouts' element={<RedeemedUserLists />} />
          </Route>

          <Route path='/dashboard/referral-payouts' element={<PrivateRoute />}>
            <Route path='/dashboard/referral-payouts' element={<ReferralPayoutUserLists />} />
          </Route>

          <Route path='/dashboard/payouts/:pagenum' element={<PrivateRoute />}>
            <Route path='/dashboard/payouts/:pagenum' element={<RedeemedUserLists />} />
          </Route>

          <Route path='/dashboard/marketplacedots' element={<PrivateRoute />}>
            <Route path='/dashboard/marketplacedots' element={<MarketPlaceListsAdmin />} />
          </Route>

          <Route path='/dashboard/archived-marketplace-dots' element={<PrivateRoute />}>
            <Route path='/dashboard/archived-marketplace-dots' element={<ArchivedMarketPlaceListsAdmin />} />
          </Route>

          <Route path='/dashboard/send-push-notification' element={<PrivateRoute />}>
            <Route path='/dashboard/send-push-notification' element={<AdminNotificationSender />} />
          </Route>

          <Route path='/dashboard/send-promotional-push-notification' element={<PrivateRoute />}>
            <Route path='/dashboard/send-promotional-push-notification' element={<AdminPromotionalNotificationSender />} />
          </Route>

          <Route path='/dashboard/user-lists' element={<PrivateRoute />}>
            <Route path='/dashboard/user-lists' element={<AdminUserList />} />
          </Route>

          <Route path='/dashboard/deactivation-requests' element={<PrivateRoute />}>
            <Route path='/dashboard/deactivation-requests' element={<DeactivateRequestsList />} />
          </Route>

          <Route path='/dashboard/admin-subscribed-users' element={<PrivateRoute />}>
            <Route path='/dashboard/admin-subscribed-users' element={<AdminSubscribedUsersList />} />
          </Route>

          <Route path='/dashboard/admin-profile-subscribed-users' element={<PrivateRoute />}>
            <Route path='/dashboard/admin-profile-subscribed-users' element={<AdminProfileSubscriptionsList />} />
          </Route>

          <Route path='/dashboard/creator-leads' element={<PrivateRoute />}>
            <Route path='/dashboard/creator-leads' element={<CreatorLeadsList />} />
          </Route>
          <Route path='/dashboard/creator-lead-detail/:id' element={<PrivateRoute />}>
            <Route path='/dashboard/creator-lead-detail/:id' element={<CreatorLeadDetail />} />
          </Route>


          <Route path='/dashboard/experiences' element={<PrivateRoute />}>
            <Route path='/dashboard/experiences' element={<ExperienceListsAdmin />} />
          </Route>

          <Route path='/dashboard/experience-drafts' element={<PrivateRoute />}>
            <Route path='/dashboard/experience-drafts' element={<ExperienceDraftsAdmin />} />
          </Route>

          <Route path='/dashboard/experience-draft-detail/:id' element={<PrivateRoute />}>
            <Route path='/dashboard/experience-draft-detail/:id' element={<ExperienceDraftDetailPage />} />
          </Route>

          <Route path='/dashboard/experience-stats' element={<PrivateRoute />}>
            <Route path='/dashboard/experience-stats' element={<CreatorStatsAdmin />} />
          </Route>

          <Route path='/dashboard/experience-detail/:id' element={<PrivateRoute />}>
            <Route path='/dashboard/experience-detail/:id' element={<ExperienceDetailPage />} />
          </Route>

          <Route path='/' element={<ConsumerLandingPage />} />

          <Route path='/download' element={<ConsumerLandingPageV2 />} />
          <Route path='/creators' element={<CreatorLandingPage />} />
          <Route path='/earn' element={<ConsumerLandingPageV2 />} />
          <Route path='/discover' element={<ConsumerLandingPage />} />
          <Route path='/welcome-new-user' element={<VasiWelcomeMobile />} />

          <Route path="/login" element={<LoginScreen />} />



          {/* <Route path='/vasipage' element={<LandingPageNew />} /> */}
          <Route path='/contact-us' element={useV2InfoPages ? <ContactUsV2 /> : <ContactUs />} />

          <Route path='/about-us' element={useV2InfoPages ? <AboutUsV2 /> : <AboutUs />} />
          <Route path="/terms-of-service-usa" element={<TermsUSA />} />
          <Route path="/terms-of-service-india" element={<TermsIndia />} />
          <Route path="/privacy-policy-usa" element={<PrivacyPolicyUSA />} />
          <Route path="/privacy-policy-india" element={<PrivacyPolicyIndia />} />
          <Route path="/faq" element={useV2InfoPages ? <FAQPageV2 /> : <FAQPage />} />
          <Route path="/guidelines-and-procedure/" element={<GuidelinesAndProcedure />} />
          <Route path="/guidelines-and-procedure/:country" element={<GuidelinesAndProcedure />} />
          <Route path="/refer-and-earn-tos" element={<ReferAndEarnTOS />} />
          <Route path="/create-share-earn-with-vasi" element={<CreateShareEarn />} />
          <Route path="/marketplace-draw-tos" element={<MarketplaceDrawTos />} />
          <Route path="/task-creation-tos" element={<TasksCreatorGuide />} />
          <Route path="/experiences-tos" element={<ExperiencesTos />} />


          <Route path="/vasi-creator-monetisation-guidelines" element={<VaSiCreatorMonetizationGuidelines />} />
           <Route path="/vasi-subscriber-guidelines" element={<VaSiSubscriberGuidelines />} />
          {/* ctaHref param is a proposed convention for the App team's WebView to
              intercept on tap and open the matching native screen instead of
              navigating. Same action for all three pages for now. Confirm the
              final param contract with the App team. */}
          <Route path="/become-a-host" element={<BecomeAHost ctaHref="/become-a-host?ctaAction=start_earning&source=webview" />} />
          <Route path="/become-a-creator" element={<BecomeAHost ctaHref="/become-a-creator?ctaAction=start_earning&source=webview" />} />
          <Route path="/monetize-your-profile" element={<BecomeAHost ctaHref="/monetize-your-profile?ctaAction=start_earning&source=webview" />} />

          {/* Zoom Meeting SDK Client View. The one-time join code arrives as ?c= and is
              the actual credential; :experienceId is there so the URL is legible and so
              analytics can tell sessions apart. Served by firebase.json's catch-all
              rewrite -- no hosting change needed. */}
          <Route path="/live/:experienceId" element={<LiveSessionPage />} />

          {/* Web fallback for the WhatsApp "recording available" link
              (/deeplink/?type=experiences&navRoute=recording&experienceId=...)
              when the native app is not installed. OTP-gated, no bearer code --
              identity comes entirely from the phone number the visitor enters. */}
          <Route path="/recordings/:experienceId" element={<ExperienceRecordingsPage />} />
          <Route path="/recordings/:experienceId/:queueId" element={<ExperienceRecordingsPage />} />

          <Route path="/deeplink" element={<DeepLinkEntryHandler />} />
          <Route path="/deeplink/*" element={<Navigate to="/" replace />} />
          <Route path="/dl/:encoded" element={<DeepLinkHandler />} />
          <Route path="/share/:hostname/:experienceId" element={<ShareRouteFallback />} />
          <Route path="/registered-success" element={<RegisteredSuccess />} />
          <Route path="/registered-cancel" element={<RegisteredCancel />} />
          <Route path="/:hostname/registration-confirmation/:experienceId" element={<ConfirmingScreen />} />
          <Route path="/:hostname/registration-success/:experienceId" element={<SuccessScreen />} />
          {/* Meta Ads-attributed registrations: same page, but looked up by Meta pixel id
              instead of experience id, mirroring the /experiences/:hostname/:pixelid landing
              route below. Lets the thank-you page fire the correct experience-specific pixel
              even when opened fresh (no navigation state), e.g. a copy-pasted link. */}
          <Route path="/experiences/:hostname/registration-success/:pixelid" element={<SuccessScreen />} />
          <Route path="/:hostname/registration-seats-full/:experienceId" element={<SeatsFullScreen />} />
          <Route path="/:hostname/registration-payment-failed/:experienceId" element={<PaymentFailedScreen />} />
          <Route path="/registration-confirmation" element={<ConfirmingScreen />} />
          <Route path="/registration-success" element={<SuccessScreen />} />
          <Route path="/debug/success-preview" element={<SuccessScreenPreview />} /> {/* TEMP DEBUG — remove before commit */}
          <Route path="/registration-seats-full" element={<SeatsFullScreen />} />
          <Route path="/registration-payment-failed" element={<PaymentFailedScreen />} />
          <Route path='/v1/:hostname/:experienceid' element={<ExperienceLandingPage />} />
          <Route path='/:hostname/:experienceid' element={<ExperienceLandingPageV2 />} />
          {/* Meta Ads entry point. Same page as the route above, but the experience is
              looked up by Meta pixel id instead of experience id — the ad link doesn't
              carry an experience id. :hostname is cosmetic here, as it is above. */}
          <Route path='/experiences/:hostname/:pixelid' element={<ExperienceLandingPageV2 />} />
          <Route path="/ask-vasi" element={<LandingPageNew />} />
          {/* <Route path="/blogs" element={<BlogPage />} />
          <Route path="/blogs/:slug" element={<BlogDetailPage />} /> */}

        </Routes>
        </Suspense>

      </div>
    </BrowserRouter>
  );
}

export default App;







